import mixpanel from 'mixpanel-browser';
import { trackLogRocketEvent } from './logrocket.ts';
import type { MixpanelEvents, MixpanelPeopleProperties } from '@/consts/observability.ts';

let initialized = false;

export const initMixpanel = () => {
  const apiKey = import.meta.env.VITE_MIXPANEL_API_KEY;
  if (!apiKey) return;
  mixpanel.init(apiKey, { debug: import.meta.env.VITE_MIXPANEL_DEBUG === 'true' });
  initialized = true;
  mixpanel.track('Mixpanel Initialized', { appVersion: import.meta.env.VITE_VERSION });
};

export const identifyTrackingServiceUser = (accountantId: string) => {
  if (!initialized) return;
  mixpanel.identify(accountantId);
};

export const setPeopleProperty = (props: MixpanelPeopleProperties) => {
  if (!initialized) return;
  mixpanel.people.set(props);
};

// TODO: Find a way to type the props properly
export const trackEvent = (eventName: MixpanelEvents, props?: object) => {
  if (!initialized) return;
  mixpanel.track(eventName, props);
  trackLogRocketEvent(eventName, props as Parameters<typeof trackLogRocketEvent>[1]);
};
